import { Student, studentsProvider } from "./studentsProvider";
import { GetListParams, GetListResult } from "react-admin";
import { AbstractDataProvider } from "./AbstractDataProvider";

class GraduatedInvoiceCustomersProvider extends AbstractDataProvider<Student> {
  async getList(_resource: string, { filter, sort, pagination }: GetListParams): Promise<GetListResult<Student>> {
    // Validate filter: must be empty or only contain drivingSchoolId
    const filterKeys = Object.keys(filter ?? {});
    if (filterKeys.length > 0 && (filterKeys.length !== 1 || filterKeys[0] !== "drivingSchoolId")) {
      throw new Error(`Unexpected filter: ${JSON.stringify(filter)} -- expected: {} or {"drivingSchoolId":"..."}`);
    }

    const { data: students, total } = await studentsProvider.getList("students", {
      filter: {
        ...(filter?.drivingSchoolId ? { drivingSchoolId: filter.drivingSchoolId } : {}),
        balance: (balance: Student["balance"]) => balance < 0,
        bookedTrainings: (bookedTrainings: Student["bookedTrainings"]) =>
          bookedTrainings.some((it) =>
            Object.values(it.kpis?.practicalExams ?? {}).some((it) => it.result === "passed"),
          ),
      },
      sort,
      pagination,
    });
    return { data: students, total };
  }
}

export const graduatedInvoiceCustomersProvider = new GraduatedInvoiceCustomersProvider();
